import { render } from "./SearchResultsItem.vue?vue&type=template&id=3c88778a&scoped=true"
import script from "./SearchResultsItem.vue?vue&type=script&lang=js"
export * from "./SearchResultsItem.vue?vue&type=script&lang=js"

import "./SearchResultsItem.vue?vue&type=style&index=0&id=3c88778a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c88778a"]])

export default __exports__